import useStores from '../stores/UseStores';
import { TBrand, TTheme } from '@teliaee/design-system';

const isValidTheme = (theme: string | undefined): theme is TTheme => {
  if (!theme) {
    return false;
  }

  const recognisedThemes = ['light', 'dark'];
  return recognisedThemes.includes(theme.toLowerCase());
};

export const useResolvedTheme = (theme: TTheme | undefined, brand: TBrand): TTheme => {
  const { routeStore } = useStores();

  if (theme) {
    return theme;
  }

  const themeParam = routeStore.getParameter('theme') as string;

  if (isValidTheme(themeParam)) {
    return themeParam.toLowerCase() as TTheme;
  }

  if (brand === 'super') {
    return 'dark';
  }

  return 'light';
};

const isValidBrand = (brand: string | undefined): brand is TBrand => {
  if (!brand) {
    return false;
  }

  const recognisedBrands = ['diil', 'telia', 'super'];
  const lowerBrand = brand.toLowerCase();
  return recognisedBrands.includes(lowerBrand);
};

export const useResolvedBrand = (brand: TBrand | undefined): TBrand => {
  const { routeStore } = useStores();

  if (brand) {
    return brand;
  }

  const brandParam = routeStore.getParameter('app') as string;

  if (isValidBrand(brandParam)) {
    return brandParam.toLowerCase() as TBrand;
  }

  const brandFromUrl = getBrandNameFromUrl();

  if (isValidBrand(brandFromUrl)) {
    return brandFromUrl.toLowerCase() as TBrand;
  }

  return 'telia';
};

export const getBrandNameFromUrl = (): TBrand => {
  return (window.location.hostname.split('.')[1] || 'telia') as TBrand;
};
